var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98736 12.7017C3.76434 12.7017 1.01196 13.2238 1.01196 15.3148C1.01196 17.4057 3.74688 17.9466 6.98736 17.9466C10.2104 17.9466 12.962 17.4236 12.962 15.3335C12.962 13.2433 10.2278 12.7017 6.98736 12.7017Z",
    stroke: "url(#paint0_linear_3476_7110)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98741 9.71933C9.10249 9.71933 10.8168 7.88174 10.8168 5.61559C10.8168 3.34943 9.10249 1.5127 6.98741 1.5127C4.87233 1.5127 3.15725 3.34943 3.15725 5.61559C3.15011 7.87409 4.85328 9.71168 6.96042 9.71933H6.98741Z",
    stroke: "url(#paint1_linear_3476_7110)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3476_7110",
    x1: 7.25037,
    y1: 18.1212,
    x2: 5.90541,
    y2: 15.1489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3476_7110",
    x1: 7.15583,
    y1: 9.99263,
    x2: 4.36813,
    y2: 7.4689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileblue);
export default __webpack_public_path__ + "static/media/profileblue.3486cf9f6ebaea2a41cba91675c3ebce.svg";
export { ForwardRef as ReactComponent };